<template>
    <div class="separator-pink">
        <div></div>
    </div>
</template>
<script>
export default {
    name: 'SeparatorPink',
    components: {},
    data() {
        return {
        }
    },
    computed: {},
    methods: {}
}
</script>